import { StockApiClient } from '@fourthwall/services/dist/StockApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const createStockMutationKey = 'createStock'

export const useCreateStockMutation = createMutationHook(StockApiClient.createStock, {
  mutationKey: [createStockMutationKey],
})
